import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';

export const MedicalInfoSection = ({ formData, handleChange }) => (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold font-[Manrope]">Medical Information</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="blood_group">Blood Group</Label>
          <Select value={formData.blood_group} onValueChange={(v) => handleChange('blood_group', v)}>
            <SelectTrigger data-testid="select-blood-group">
              <SelectValue placeholder="Select blood group" />
            </SelectTrigger>
            <SelectContent position="popper" sideOffset={5}>
              <SelectItem value="A+">A+</SelectItem>
              <SelectItem value="A-">A-</SelectItem>
              <SelectItem value="B+">B+</SelectItem>
              <SelectItem value="B-">B-</SelectItem>
              <SelectItem value="AB+">AB+</SelectItem>
              <SelectItem value="AB-">AB-</SelectItem>
              <SelectItem value="O+">O+</SelectItem>
              <SelectItem value="O-">O-</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label htmlFor="patient_type">Patient Type *</Label>
          <Select value={formData.patient_type} onValueChange={(v) => handleChange('patient_type', v)}>
            <SelectTrigger data-testid="select-patient-type">
              <SelectValue placeholder="Select type" />
            </SelectTrigger>
            <SelectContent position="popper" sideOffset={5}>
              <SelectItem value="outdoor">Outdoor (OPD)</SelectItem>
              <SelectItem value="indoor">Indoor (Admission)</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="md:col-span-2">
          <Label htmlFor="allergies">Known Allergies</Label>
          <Textarea
            id="allergies"
            value={formData.allergies}
            onChange={(e) => handleChange('allergies', e.target.value)}
            placeholder="List any known allergies"
            data-testid="input-allergies"
          />
        </div>

        <div className="md:col-span-2">
          <Label htmlFor="medical_history">Medical History</Label>
          <Textarea
            id="medical_history"
            value={formData.medical_history}
            onChange={(e) => handleChange('medical_history', e.target.value)}
            placeholder="Previous medical conditions, surgeries, etc."
            data-testid="input-medical-history"
          />
        </div>
      </CardContent>
    </Card>

);
